/**
 * Conditional Skin Guide questions (Amy doctrine v3 / Cos 3.1).
 * Used by the page section and the header modal.
 */
(function () {
  function list(v) {
    if (!v) return [];
    return Array.isArray(v) ? v : [v];
  }
  function over45(a) {
    return a.age_band === '46_54' || a.age_band === '55_plus';
  }
  function under25(a) {
    return a.age_band === 'under_18' || a.age_band === '18_24';
  }
  function hasGoal(a, goal) {
    return a.primary_goal === goal || list(a.secondary_goals).indexOf(goal) !== -1;
  }
  function namedMed(a) {
    var t = a.medication_type;
    return t === 'tretinoin' || t === 'differin' || t === 'isotretinoin' || t === 'other' || a.skin_medication === 'yes';
  }
  function retinolLikely(a) {
    if (a.rosacea === 'yes') return false;
    if (a.dryness === 'severe' || a.sensitivity === 'burning_now') return false;
    var repro = list(a.reproductive_context);
    if (repro.indexOf('pregnant') !== -1 || repro.indexOf('conceiving') !== -1 || repro.indexOf('breastfeeding') !== -1) return false;
    if (namedMed(a)) return false;
    if (under25(a) && !hasGoal(a, 'breakouts')) return false;
    return hasGoal(a, 'breakouts') || hasGoal(a, 'lines');
  }

  var QUESTIONS = [
    {
      id: 'age_band',
      name: 'age_band',
      label: 'What is your age range?',
      options: [
        { value: 'under_18', label: 'Under 18' },
        { value: '18_24', label: '18–24' },
        { value: '25_45', label: '25–45' },
        { value: '46_54', label: '46–54' },
        { value: '55_plus', label: '55+' },
        { value: 'prefer_not', label: 'Prefer not to say' },
      ],
    },
    {
      id: 'primary_goal',
      name: 'primary_goal',
      label: 'What would you most like help with?',
      options: [
        { value: 'breakouts', label: 'Breakouts' },
        { value: 'dry_tight', label: 'Dry or tight skin' },
        { value: 'sensitivity', label: 'Sensitivity' },
        { value: 'marks', label: 'Dark spots or discoloration' },
        { value: 'lines', label: 'Lines or firmness' },
        { value: 'maintain', label: 'Maintaining healthy skin' },
      ],
    },
    {
      id: 'secondary_goals',
      name: 'secondary_goals',
      label: 'Anything else — optional.',
      hint: 'Pick up to 2, or skip.',
      type: 'multi',
      max: 2,
      skipLabel: 'Just the one',
      options: [
        { value: 'breakouts', label: 'Breakouts' },
        { value: 'dry_tight', label: 'Dry or tight skin' },
        { value: 'sensitivity', label: 'Sensitivity' },
        { value: 'marks', label: 'Dark spots or discoloration' },
        { value: 'lines', label: 'Lines or firmness' },
        { value: 'none', label: 'Nothing else' },
      ],
    },
    {
      id: 'dryness',
      name: 'dryness',
      label: 'How often does your skin feel dry, tight, or flaky?',
      options: [
        { value: 'none', label: 'Not at all' },
        { value: 'sometimes', label: 'Sometimes' },
        { value: 'often', label: 'Often' },
        { value: 'severe', label: 'My skin is extremely dry or uncomfortable' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'oil_pattern',
      name: 'oil_pattern',
      label: 'By the middle of the day, where do you usually notice shine or oil?',
      options: [
        { value: 'nowhere', label: 'Nowhere' },
        { value: 'tzone', label: 'Mainly my forehead, nose, or chin' },
        { value: 'most_face', label: 'Across most of my face' },
        { value: 'varies', label: 'It varies' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'sensitivity',
      name: 'sensitivity',
      label: 'Does skincare often sting or irritate your skin?',
      options: [
        { value: 'rarely', label: 'Rarely' },
        { value: 'sometimes', label: 'Sometimes' },
        { value: 'frequently', label: 'Frequently' },
        { value: 'burning_now', label: 'Burning or peeling right now' },
      ],
    },
    {
      id: 'rosacea',
      name: 'rosacea',
      label: 'Have you been diagnosed with rosacea?',
      options: [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'reproductive_context',
      name: 'reproductive_context',
      label: 'Are you pregnant, trying to conceive, or breastfeeding?',
      type: 'multi',
      max: 3,
      options: [
        { value: 'none', label: 'None of these' },
        { value: 'pregnant', label: 'Pregnant' },
        { value: 'conceiving', label: 'Trying to conceive' },
        { value: 'breastfeeding', label: 'Breastfeeding' },
        { value: 'prefer_not', label: 'Prefer not to say' },
      ],
    },
    {
      id: 'medication_type',
      name: 'medication_type',
      label: 'Are you currently using tretinoin (Retin-A), Differin/adapalene, isotretinoin (Accutane), or another prescription skin treatment?',
      options: [
        { value: 'tretinoin', label: 'Tretinoin / Retin-A' },
        { value: 'differin', label: 'Differin / adapalene' },
        { value: 'isotretinoin', label: 'Oral isotretinoin / Accutane' },
        { value: 'other', label: 'Another prescription skin treatment' },
        { value: 'none', label: 'None' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'medication_other_name',
      name: 'medication_other_name',
      type: 'text',
      input: 'text',
      label: 'What prescription skin treatment are you using?',
      placeholder: 'Medication name',
      showIf: function (a) { return a.medication_type === 'other'; },
    },
    {
      id: 'prescription_satisfaction',
      name: 'prescription_satisfaction',
      label: 'Are you pleased with how your current treatment is working?',
      showIf: namedMed,
      options: [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
        { value: 'unsure', label: 'Unsure / too soon' },
      ],
    },
    {
      id: 'current_actives',
      name: 'current_actives',
      label: 'Which treatment products do you already use?',
      type: 'multi',
      max: 4,
      options: [
        { value: 'none', label: 'None of these' },
        { value: 'retinol', label: 'Retinol or a retinoid' },
        { value: 'acid', label: 'An acid exfoliant' },
        { value: 'brightening', label: 'A brightening serum' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'retinol_experience',
      name: 'retinol_experience',
      label: 'Have you used retinol before, and how did your skin tolerate it?',
      showIf: retinolLikely,
      options: [
        { value: 'never', label: 'Never' },
        { value: 'comfortably', label: 'Yes — comfortably' },
        { value: 'irritated', label: 'Yes — it irritated me' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'acne_pattern',
      name: 'acne_pattern',
      label: 'What do breakouts usually look like for you?',
      hint: 'Pick all that apply.',
      showIf: function (a) { return hasGoal(a, 'breakouts'); },
      type: 'multi',
      max: 3,
      options: [
        { value: 'congestion', label: 'Congestion, blackheads, or whiteheads' },
        { value: 'inflamed', label: 'Inflamed pimples' },
        { value: 'deep_scarring', label: 'Deep painful bumps or scarring' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'pigment_pattern',
      name: 'pigment_pattern',
      label: 'Which type of discoloration would you like help with?',
      hint: 'Pick all that apply. These are everyday descriptions, not a diagnosis.',
      showIf: function (a) { return hasGoal(a, 'marks') || hasGoal(a, 'breakouts'); },
      type: 'multi',
      max: 5,
      options: [
        { value: 'pih', label: 'Dark spots left after acne or irritation' },
        { value: 'sun_spots', label: 'Sun spots, age spots, or other brown spots' },
        { value: 'melasma', label: 'Melasma or larger patches of discoloration' },
        { value: 'uneven_tone', label: 'Overall uneven tone or dullness' },
        { value: 'prevention', label: 'Preventing future discoloration' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'pigment_priority',
      name: 'pigment_priority',
      label: 'Which of those is the main priority?',
      hint: 'Pick all that apply.',
      type: 'multi',
      max: 5,
      showIf: function (a) {
        var p = list(a.pigment_pattern).filter(function (v) {
          return v && v !== 'unsure' && v !== 'none' && v !== 'mixed';
        });
        return p.length > 1 || a.pigment_pattern === 'mixed';
      },
      options: [
        { value: 'pih', label: 'Dark spots left after acne or irritation' },
        { value: 'sun_spots', label: 'Sun spots, age spots, or other brown spots' },
        { value: 'melasma', label: 'Melasma or larger patches' },
        { value: 'uneven_tone', label: 'Uneven tone or dullness' },
        { value: 'prevention', label: 'Prevention' },
      ],
    },
    {
      id: 'spot_change',
      name: 'spot_change',
      label: 'Is any spot changing, bleeding, or otherwise concerning?',
      showIf: function (a) {
        var p = list(a.pigment_pattern).concat(list(a.pigment_priority));
        return p.indexOf('sun_spots') !== -1 || p.indexOf('melasma') !== -1 || p.indexOf('mixed') !== -1;
      },
      options: [
        { value: 'no', label: 'No' },
        { value: 'yes', label: 'Yes' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'exfoliation_goal',
      name: 'exfoliation_goal',
      label: 'Would you like an occasional exfoliating cleanser included?',
      showIf: function (a) {
        return hasGoal(a, 'breakouts') || a.dryness === 'often';
      },
      options: [
        { value: 'yes', label: 'Yes, as needed' },
        { value: 'no', label: 'Not right now' },
      ],
    },
    {
      id: 'eye_requested',
      name: 'eye_requested',
      label: 'Would you like eye-care recommendations?',
      showIf: function (a) { return !over45(a) && a.age_band !== 'prefer_not'; },
      options: [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No thanks' },
      ],
    },
    {
      id: 'eye_goal',
      name: 'eye_goal',
      label: 'What matters most around the eyes?',
      showIf: function (a) { return over45(a) || a.eye_requested === 'yes'; },
      options: [
        { value: 'lines', label: 'Fine lines' },
        { value: 'puffiness', label: 'Puffiness or dark circles' },
        { value: 'both', label: 'Both' },
        { value: 'general', label: 'General care' },
      ],
    },
    {
      id: 'neck_requested',
      name: 'neck_requested',
      label: 'Would you like a neck cream included?',
      showIf: function (a) { return !over45(a) && a.age_band !== 'prefer_not'; },
      options: [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No thanks' },
      ],
    },
    {
      id: 'body_requested',
      name: 'body_requested',
      label: 'Would you also like body-care recommendations?',
      options: [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'Just my face' },
      ],
    },
    {
      id: 'body_goal',
      name: 'body_goal',
      label: 'What would you like body care to address?',
      showIf: function (a) { return a.body_requested === 'yes'; },
      options: [
        { value: 'dryness_firmness', label: 'Dryness or firmness' },
        { value: 'kp', label: 'Diagnosed keratosis pilaris' },
        { value: 'other_bumps', label: 'Other bumps' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'spf_finish',
      name: 'spf_finish',
      label: 'For sunscreen, do you prefer a matte or dewy finish?',
      options: [
        { value: 'matte', label: 'Matte' },
        { value: 'dewy', label: 'Dewy' },
        { value: 'no_preference', label: 'No preference' },
      ],
    },
    {
      id: 'known_reactions',
      name: 'known_reactions',
      label: 'Are there skincare ingredients or products you know you react to?',
      options: [
        { value: 'none', label: 'None that I know of' },
        { value: 'yes', label: 'Yes' },
        { value: 'unsure', label: 'Unsure' },
      ],
    },
    {
      id: 'known_reaction_cause',
      name: 'known_reaction_cause',
      label: 'Which ingredient or product caused the reaction?',
      showIf: function (a) { return a.known_reactions === 'yes'; },
      options: [
        { value: 'retinol', label: 'Retinol or a retinoid' },
        { value: 'niacinamide', label: 'Niacinamide' },
        { value: 'vitamin_c', label: 'Vitamin C' },
        { value: 'aha', label: 'An AHA / glycolic / lactic acid' },
        { value: 'spf', label: 'Sunscreen / SPF' },
        { value: 'other', label: 'Something else' },
        { value: 'unsure', label: 'Unsure what caused it' },
      ],
    },
    {
      id: 'known_reaction_other',
      name: 'known_reaction_other',
      type: 'text',
      input: 'text',
      label: 'Which ingredient or product was it?',
      placeholder: 'Ingredient or product name',
      showIf: function (a) { return a.known_reactions === 'yes' && a.known_reaction_cause === 'other'; },
    },
    {
      id: 'known_reaction_what',
      name: 'known_reaction_what',
      type: 'text',
      input: 'textarea',
      optional: true,
      label: 'What happened when you used it?',
      placeholder: 'For example: redness, burning, rash…',
      showIf: function (a) { return a.known_reactions === 'yes'; },
    },
    {
      id: 'routine_preference',
      name: 'routine_preference',
      label: 'Would you like a simple starting routine or additional targeted options?',
      options: [
        { value: 'simple', label: 'Simple starting routine' },
        { value: 'additional', label: 'Additional targeted options' },
      ],
    },
  ];

  function visibleQuestions(answers) {
    return QUESTIONS.filter(function (q) {
      return !q.showIf || q.showIf(answers);
    });
  }

  function pruneHidden(answers) {
    var vis = {};
    visibleQuestions(answers).forEach(function (q) { vis[q.name] = true; });
    Object.keys(answers).forEach(function (k) {
      var still = QUESTIONS.some(function (q) { return q.name === k && vis[q.name]; });
      if (!still && k) {
        var def = QUESTIONS.find(function (q) { return q.name === k; });
        if (def && def.showIf && !def.showIf(answers)) delete answers[k];
      }
    });
  }

  function escapeAttr(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function init(opts) {
    var mount = opts.mount;
    var progressBar = opts.progressBar;
    var progressLabel = opts.progressLabel;
    var backBtn = opts.backBtn;
    var onComplete = opts.onComplete;
    var answers = {};
    var history = [];
    var index = 0;

    function currentList() {
      pruneHidden(answers);
      return visibleQuestions(answers);
    }

    function setProgress(i, total) {
      var pct = total ? Math.round((i / total) * 100) : 0;
      if (progressBar) {
        progressBar.style.width = pct + '%';
        progressBar.setAttribute('aria-valuenow', String(pct));
      }
      if (progressLabel) progressLabel.textContent = 'Question ' + (i + 1) + ' of ' + total;
    }

    function render() {
      var listQ = currentList();
      if (index >= listQ.length) {
        onComplete(answers);
        return;
      }
      var q = listQ[index];
      setProgress(index, listQ.length);
      if (backBtn) backBtn.hidden = index === 0;

      var html = '<div class="aso-quiz-step" data-q="' + q.id + '">';
      html += '<p class="aso-quiz-step__label">' + q.label + '</p>';
      if (q.hint) html += '<p class="aso-quiz-step__hint">' + q.hint + '</p>';

      if (q.type === 'text') {
        var storedText = answers[q.name] || '';
        if (q.input === 'textarea') {
          html += '<textarea class="aso-quiz-text" data-aso-text rows="3" placeholder="' + escapeAttr(q.placeholder) + '">' + escapeAttr(storedText) + '</textarea>';
        } else {
          html += '<input class="aso-quiz-text aso-quiz-text--input" data-aso-text type="text" placeholder="' + escapeAttr(q.placeholder) + '" value="' + escapeAttr(storedText) + '">';
        }
        html += '<div class="aso-quiz-step__nav"><button type="button" class="aso-quiz-option-next aso-btn-primary" data-aso-continue' +
          (q.optional || storedText ? '' : ' disabled') + '>Continue</button></div>';
        html += '</div>';
        mount.innerHTML = html;
        if (typeof opts.onRender === 'function') opts.onRender();
        var textEl = mount.querySelector('[data-aso-text]');
        var contBtn = mount.querySelector('[data-aso-continue]');
        if (textEl && contBtn && !q.optional) {
          textEl.addEventListener('input', function () {
            contBtn.disabled = !textEl.value.trim();
          });
        }
        return;
      }

      var multi = q.type === 'multi';
      var opts = q.options || [];
      if (q.id === 'pigment_priority') {
        var selected = list(answers.pigment_pattern);
        var filtered = opts.filter(function (opt) { return selected.indexOf(opt.value) !== -1; });
        if (filtered.length) opts = filtered;
      }
      html += '<div class="aso-quiz-options' + (opts.length > 4 ? ' aso-quiz-options--grid' : '') + '" data-name="' + q.name + '"' +
        (multi ? ' data-multi="true" data-max="' + (q.max || 3) + '"' : '') + '>';
      opts.forEach(function (opt) {
        html += '<button type="button" class="aso-quiz-option" data-value="' + opt.value + '">' + opt.label + '</button>';
      });
      html += '</div>';
      if (multi) {
        html += '<div class="aso-quiz-step__nav"><button type="button" class="aso-quiz-option-next aso-btn-primary" data-aso-continue disabled>Continue</button></div>';
      }
      html += '</div>';
      mount.innerHTML = html;
      if (typeof opts.onRender === 'function') opts.onRender();

      var stored = answers[q.name];
      if (stored != null) {
        var vals = Array.isArray(stored) ? stored : [stored];
        mount.querySelectorAll('.aso-quiz-option').forEach(function (b) {
          if (vals.indexOf(b.getAttribute('data-value')) !== -1) b.classList.add('is-active');
        });
        var cont = mount.querySelector('[data-aso-continue]');
        if (cont && vals.length) cont.disabled = false;
      }
    }

    function advance() {
      history.push(index);
      index += 1;
      var listQ = currentList();
      if (index >= listQ.length) {
        pruneHidden(answers);
        onComplete(answers);
        return;
      }
      render();
    }

    mount.addEventListener('click', function (e) {
      var btn = e.target.closest('.aso-quiz-option');
      var cont = e.target.closest('[data-aso-continue]');
      if (cont) {
        e.preventDefault();
        if (cont.disabled) return;
        var textEl = mount.querySelector('[data-aso-text]');
        if (textEl) {
          var listQ = currentList();
          var q = listQ[index];
          if (q && q.type === 'text') answers[q.name] = textEl.value.trim();
        }
        advance();
        return;
      }
      if (!btn || !mount.contains(btn)) return;
      var container = btn.closest('[data-name]');
      if (!container) return;
      var name = container.getAttribute('data-name');
      var multi = container.getAttribute('data-multi') === 'true';
      var max = parseInt(container.getAttribute('data-max') || '1', 10);
      var value = btn.getAttribute('data-value');

      if (!multi) {
        container.querySelectorAll('.aso-quiz-option').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        answers[name] = value;
        setTimeout(advance, 140);
        return;
      }

      var isExclusive = value === 'none' || value === 'prefer_not' || value === 'unsure';
      if (isExclusive) {
        container.querySelectorAll('.aso-quiz-option').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        answers[name] = value === 'prefer_not' ? 'prefer_not' : [value];
      } else if (btn.classList.contains('is-active')) {
        btn.classList.remove('is-active');
        var remaining = Array.prototype.map.call(
          container.querySelectorAll('.aso-quiz-option.is-active'),
          function (b) { return b.getAttribute('data-value'); }
        ).filter(function (v) { return v !== 'none' && v !== 'prefer_not' && v !== 'unsure'; });
        answers[name] = remaining;
      } else {
        container.querySelectorAll('[data-value="none"], [data-value="prefer_not"], [data-value="unsure"]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        var now = container.querySelectorAll('.aso-quiz-option.is-active').length;
        if (now < max) btn.classList.add('is-active');
        var finalActive = Array.prototype.map.call(
          container.querySelectorAll('.aso-quiz-option.is-active'),
          function (b) { return b.getAttribute('data-value'); }
        ).filter(function (v) { return v !== 'none' && v !== 'prefer_not' && v !== 'unsure'; });
        if (finalActive.indexOf('prefer_not') !== -1) answers[name] = 'prefer_not';
        else answers[name] = finalActive;
      }
      var c = mount.querySelector('[data-aso-continue]');
      if (c) c.disabled = container.querySelectorAll('.aso-quiz-option.is-active').length === 0;
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (!history.length) return;
        index = history.pop();
        render();
      });
    }

    return {
      start: function () {
        answers = {};
        history = [];
        index = 0;
        render();
      },
      getAnswers: function () { return answers; },
    };
  }

  window.asoSkinGuideFlow = { init: init, questions: QUESTIONS };
})();
